import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-applied-filters-row',
  templateUrl: './applied-filters-row.component.html',
  styleUrls: ['./applied-filters-row.component.scss'],
})
export class AppliedFiltersRowComponent {
  @Input() appliedFilters: any[] = [];
  @Output() removeFilter = new EventEmitter<any>();
  @Output() clearFiltersAndRefresh = new EventEmitter<any>();

  onRemoveFilter(filter: any) {
    this.removeFilter.emit(filter);
  }

  onClearFiltersAndRefresh() {
    this.clearFiltersAndRefresh.emit();
  }
}
